import { Stage } from "@amzn/ask-legal-domain";

export interface ClientConfig {
    apiEndpoint: {
        customDomain: string;
        regionalDomain: string;
    };
    cognito: {
        userPoolName: string;
        clientId: string;
        domain: string;
        signInRedirectUrl: string;
        signOutRedirectUrl: string;
        responseType: string;
        scope: string[]
    };
    awsRegion: string;
    stage: string;
    source?: {
        url: string;
    };
    quickAgentChat?: {
        url: string;
    };
}

function parseOptionalUrl(config: { url?: string } | undefined): { url: string } | undefined {
    try {
        if (config && typeof config.url === "string" && config.url.length > 0) {
            new URL(config.url);
            return { url: config.url };
        }
    } catch (e) {
        console.error("Invalid quickAgentChat configuration:", e);
    }
    return undefined;
}

export class ClientConfigFactory {
    public static async getStage (): Promise<string> {
        const stageSettingFile = "settings.json";
        const stageSettingPath = `${location.origin}/${stageSettingFile}`;
        try {
            const res = await fetch(stageSettingPath);
            const data = await res.json();
            const stage = data.stage;
            return stage;
        } catch (e) {
            console.warn(`Fallback to ${Stage.Local}`);
            return Stage.Local;
        }
    }

    public static async getConfig (): Promise<ClientConfig> {
        const stage = await ClientConfigFactory.getStage();
        const configFile = "stage_config/" + stage + "/config.json";
        const configPath = `${location.origin}/${configFile}`;
        const res = await fetch(configPath);
        const data = await res.json();
        const config: ClientConfig = {
            apiEndpoint: {
                customDomain: data.apiEndpoints.customDomain,
                regionalDomain: data.apiEndpoints.regionalDomain
            },
            cognito: {
                userPoolName: data.cognito.userPoolName,
                clientId: data.cognito.clientId,
                domain: data.cognito.domain,
                signInRedirectUrl: data.cognito.signInRedirectUrl,
                signOutRedirectUrl: data.cognito.signOutRedirectUrl,
                responseType: data.cognito.responseType,
                scope: data.cognito.scope,
            },
            awsRegion: data.awsRegion,
            stage: stage,
            source: !!data.source && {
                url: data.source.url
            },
            quickAgentChat: parseOptionalUrl(data.quickAgentChat)
        };
        return config;
    }
}
